// @flow
/**
 */
export type MessageParameters = {
  [parameterName: string]: string | number,
};

/**
 */
export type MessageObject = {
  +id: string,
  +defaultMessage?: string,
  +parameters?: MessageParameters,
};

/**
 */
export type LocaleConfiguration = {
  code: string,
  messages: Object,
  errors?: Object,
  nativeName?: string,
};
